
import { DataGroup } from "../../../models/dataGroup.model.ts";
import { DataGroupTeamSerializer } from "../../../models/serializers/dataGroupTeamSerializer.ts";
import { UseCaseStep } from "../../../models/useCaseStep.model.ts";

import { httpRequest } from "../../http";

export class CommandUseCaseSteps {
    //TODO ADD PARAMS
    async run( engagementId:string, objectiveId: string, useCaseStep: UseCaseStep[]) {  
    
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/objectives/${objectiveId}/steps/`

        try {
            const response = await httpRequest<any>(url, { method: "PATCH", body: useCaseStep });
            //TODO ADD SERIALIZER
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : DataGroup []{
        const serializer = new DataGroupTeamSerializer();
        return serializer.deserializeList(data);
    }
}

